import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'

import {
  COLOR_VALUE,
  DENTIN_TYPE,
} from '@/pages/getRecipe/allInOne/utils/constants'
import {
  FORM_FIELDS,
  type FormData,
} from '@/pages/getRecipe/allInOne/utils/formTypes'

type FormState = {
  form: { [key in keyof FormData]?: any }
  recipeActiveStep: number
  selectedPickerKey: string
  allInOneRecipeOutput: any
  generation_id?: string | number
}

const initialState: FormState = {
  form: {
    [FORM_FIELDS.RECIPE_TYPE]: DENTIN_TYPE.SINGLE_DENTIN,
    [FORM_FIELDS.AVAILSPACE_CERVICAL]: 0.5,
    [FORM_FIELDS.AVAILSPACE_MIDDLE]: 0.5,
    [FORM_FIELDS.AVAILSPACE_INCISAL]: 0.5,
    [FORM_FIELDS.PREPCOLOR_CERVICAL]: [null, null, null],
    [FORM_FIELDS.PREPCOLOR_MIDDLE]: [null, null, null],
    [FORM_FIELDS.PREPCOLOR_INCISAL]: [null, null, null],
    [FORM_FIELDS.TARGETCERVICAL]: [null, null, null],
    [FORM_FIELDS.TARGETMIDDLE]: [null, null, null],
    [FORM_FIELDS.TARGETINCISAL]: [null, null, null],
    [FORM_FIELDS.PREP_COLOR]: COLOR_VALUE.LabColor,
    [FORM_FIELDS.DENTIN_COLOR]: COLOR_VALUE.LabColor,
  },
  recipeActiveStep: 0,
  selectedPickerKey: '',
  allInOneRecipeOutput: null,
  generation_id: undefined,
}

export const allInOneSlice = createSlice({
  name: 'allInOne',
  initialState,
  reducers: {
    updateAllInOneFormValue: (
      state,
      action: PayloadAction<{ name: keyof FormData; value: any }>,
    ) => {
      return {
        ...state,
        form: {
          ...state.form,
          [action.payload.name]: action.payload.value,
        },
      }
    },
    setRecipeActiveStep: (state, action: PayloadAction<number>) => {
      return {
        ...state,
        recipeActiveStep: action.payload,
      }
    },
    setSelectedPickerKey: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        selectedPickerKey: action.payload,
      }
    },
    setAllInOneRecipeOutput: (
      state,
      action: PayloadAction<{
        result: any
        generation_id?: string | number
      }>,
    ) => {
      return {
        ...state,
        allInOneRecipeOutput: action.payload.result,
        generation_id: action.payload.generation_id,
      }
    },
    clearAllInOneState: () => initialState,
    resetAllInOneState: (state) => {
      return {
        ...initialState,
        allInOneRecipeOutput: state.allInOneRecipeOutput,
        generation_id: state.generation_id,
      }
    },
  },
})

export const {
  updateAllInOneFormValue,
  setRecipeActiveStep,
  setSelectedPickerKey,
  clearAllInOneState,
  setAllInOneRecipeOutput,
  resetAllInOneState,
} = allInOneSlice.actions
export default allInOneSlice.reducer
